import {FieldType} from "../../../fields3/field-type"
import {CustomFieldScope} from "../@const"
import {CURRENCY_OPTIONS} from "../../../gd/const/currency"
import FieldsCollection from "../../../fields3/collection/base/fields-collection"
import FieldMultiselectCheckbox from "../../../fields3/generic/multiselect-checkbox/multiselect-checkbox"
import FieldDropdown from "../../../fields3/generic/dropdown/dropdown"
import FieldStepper from "../../../fields3/generic/stepper/stepper"
import FieldToggle from "../../../fields3/generic/boolean/toggle/toggle"
import {EntityType} from "../../../gd/const/item"

const baseConfig = [
    {
        fieldId         : 'scope',
        label           : 'Scope',
        type            : FieldType.MULTISELECT_CHECKBOX,
        description     : 'Select where this custom field applies — to tasks, folders, or both.',
        options         : [
            {value: CustomFieldScope.TASK,       label: "Tasks"},
            {value: CustomFieldScope.PROJECT,    label: "Folders"},
            // {value: CustomFieldScope.USER,       label: "Users"}
        ],
    },

    // Textarea (probably it is redundant field and size is not used anymore)
    {
        fieldId         : 'size',
        label           : 'Max Size',
        type            : FieldType.DROPDOWN,
        description     : 'Set the maximum visible height of the textarea by selecting how many lines it should display at once.',
        options         : [
            {label:'2 Lines', value: 2},
            {label:'3 Lines', value: 3},
            {label:'4 Lines', value: 4},
            {label:'5 Lines', value: 5},
            {label:'6 Lines', value: 6},
            {label:'8 Lines', value: 8},
            {label:'10 Lines', value: 10},
            {label:'12 Lines', value: 12},
        ],
        noValueOption   : false,
        showMenuMore    : false
    },

    {
        fieldId     : 'decimalPlaces',
        label       : 'Decimal places',
        type        : FieldType.STEPPER,
        description : 'Specify how many digits should appear after the decimal point.',
        minValue    : 0,
        maxValue    : 9,
    },

    {
        fieldId     : 'positiveOnly',
        label       : 'Positive only',
        type        : FieldType.TOGGLE,
        description : 'Allow only positive numbers (greater than or equal to zero).',
    },

    {
        fieldId     : 'integersOnly',
        label       : 'Integers only',
        type        : FieldType.TOGGLE,
        description : 'Accept only numbers without fractions or decimals.',
    },

    {
        fieldId         : 'symbol',
        label           : 'Symbol',
        type            : FieldType.DROPDOWN,
        description     : 'Select the currency symbol to display with the value.',
        options         : CURRENCY_OPTIONS,
        noValueOption   : false,
        showMenuMore    : false
    },
]

export default class CustomFieldParamsFields extends FieldsCollection {

    // Quick access
    get scope()         : FieldMultiselectCheckbox { return this.get('scope') as FieldMultiselectCheckbox }
    get size()          : FieldDropdown { return this.get('size') as FieldDropdown }
    get decimalPlaces() : FieldStepper { return this.get('decimalPlaces') as FieldStepper }
    get positiveOnly()  : FieldToggle { return this.get('positiveOnly') as FieldToggle }
    get integersOnly()  : FieldToggle { return this.get('integersOnly') as FieldToggle }
    get symbol()        : FieldDropdown { return this.get('symbol') as FieldDropdown }

    constructor() {
        super(baseConfig, EntityType.DYNAMIC_MODEL)
    }
}